module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/rectangle-5-13163b8299c88e4ffafe552559121b91.png";